module.exports = __webpack_public_path__ + "img/logo.de9f5e9d.png";